import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { ProductList, ProductListCounts } from '../models/product.model';
import { DropdownData } from 'libs/shared/src/lib/models/dropdown.models';

@Injectable({
  providedIn: 'root'
})
export class ProductListService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readProductList(showLoader = true): Observable<ProductList[]> {
    return this.#http.getData(`${this.baseUrl}/product-lists?includeInactive=false`, {
      showLoader,
      showMessage: false
    });
  }

  readProductListById(id: string): Observable<ProductList> {
    return this.#http.getData(`${this.baseUrl}/product-lists/${id}`, { showLoader: true, showMessage: false });
  }

  createProductList(productList: any): Observable<any> {
    return this.#http.postData(`${this.baseUrl}/product-lists`, { showLoader: true, showMessage: true }, productList);
  }

  updateProductList(productList: any): Observable<any> {
    return this.#http.putData(`${this.baseUrl}/product-lists/${productList.id}`, productList, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteProductList(id: string): Observable<any> {
    return this.#http.deleteData(`${this.baseUrl}/product-lists/${id}`, { showLoader: true, showMessage: true });
  }

  readProductCategoriesByProductListId(productListId: string): Observable<{ [productListId: string]: DropdownData[] }> {
    return this.#http.getData(`${this.baseUrl}/product-lists/${productListId}/categories`, {
      showLoader: true,
      showMessage: false
    });
  }

  readProductListCounts(productListId: string): Observable<ProductListCounts | null> {
    return this.#http
      .getData<ProductListCounts>(`${this.baseUrl}/product-lists/${productListId}/counts`, {
        showLoader: false,
        showMessage: false,
        showError: false
      })
      .pipe(catchError(() => of(null)));
  }
}
